import { render } from "./IconDownloadPatient.vue?vue&type=template&id=3207eb36"
import script from "./IconDownloadPatient.vue?vue&type=script&lang=js"
export * from "./IconDownloadPatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__